/**
 * 权限指令 v-permission
 * 使用方式：
 *   v-permission="'add'"                  // 需要add权限
 *   v-permission="['add', 'edit']"        // 需要add或edit权限
 *   v-permission:disabled="'delete'"      // 没有权限时禁用而非隐藏
 */
export default {
    inserted(el, binding, vnode) {
        const { value, arg } = binding
        
        // 检查是否是超级管理员
        let isSuperAdmin = false
        try {
            const userStr = localStorage.getItem('user')
            if (userStr) {
                const user = JSON.parse(userStr)
                // identity !== 3 表示不是商户管理员，即超级管理员
                isSuperAdmin = user.identity !== 3
            }
        } catch (e) {
            console.warn('获取用户信息失败:', e)
        }
        
        // 如果是超级管理员，直接允许所有操作
        if (isSuperAdmin) {
            return
        }
        
        // 安全地获取权限列表
        let permissions = []
        try {
            const permsStr = localStorage.getItem('permissions')
            if (permsStr) {
                const parsedPerms = JSON.parse(permsStr) || []
                // 处理权限数据格式：可能是数组嵌套的情况
                permissions = parsedPerms.flat().filter(p => typeof p === 'string')
            }
        } catch (e) {
            console.warn('获取权限列表失败:', e)
            permissions = []
        }

        if (value) {
            const routeKey = window.location.hash.replace('#', '');
            let requiredPerms;
            if (Array.isArray(value)) {
                requiredPerms = value.map(i => routeKey + ":" + i)
            } else {
                requiredPerms = [routeKey + ":" + value]
            }
            
            // 检查权限：支持完整匹配和部分匹配
            const hasPermission = permissions.some(perm => {
                if (typeof perm !== 'string') return false
                // 完整匹配
                if (requiredPerms.includes(perm)) return true
                // 部分匹配：检查权限字符串是否包含所需的权限名
                return requiredPerms.some(reqPerm => {
                    const permName = reqPerm.split(':').pop()
                    return perm.includes(permName) || perm.endsWith(':' + permName)
                })
            })

            if (!hasPermission) {
                if (arg === 'disabled') {
                    // 禁用元素
                    el.disabled = true
                    el.classList.add('is-disabled')
                    el.setAttribute('title', '无权限操作')
                } else {
                    // 默认行为：移除元素
                    el.parentNode && el.parentNode.removeChild(el)
                }
            }
        } else {
            throw new Error(`需要指定权限，如 v-permission="'add'"`)
        }
    }
}